var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"structure"},[_c('h1',[_vm._v("组织机构")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imgUrl.replace('s_', ''),"alt":"","srcset":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }